
import { useRef } from "react";
import { useOnClickOutside } from "./useOnClickOutside";

export function useOutsideClickRef<T extends HTMLElement = HTMLElement>(
  handler: (event: MouseEvent | TouchEvent) => void
) {
  const ref = useRef<T>(null);
  useOnClickOutside(ref, handler);
  return ref;
}
